export default __webpack_public_path__ + "static/media/covid-header-close.23bbb6bc.svg";